import Lottie from 'lottie-react';

import loveCare from '../jsons/wired-flat-436-love-care-in-reveal.json';

const LoveCare = props => {
  return <Lottie loop={false} animationData={loveCare} {...props} />;
};

export default LoveCare;
